<template>
    <v-navigation-drawer app v-model="openedDrawer" class="grey darken-4">
        <v-list dense flat nav dark>
            <v-list-item class="pa-2 mb-2">
                <v-img
                    :src="require('@/assets/img/connectplug-logo-azul.png')"
                    max-height="40px"
                    contain
                ></v-img>
            </v-list-item>

            <v-divider class="grey darken-2"></v-divider>

            <v-list-item>
                <v-list-item-title class="subtitle-2 mt-4 mb-4 text-center">{{
                    $store.getters['auth/user'].name
                }}</v-list-item-title>
            </v-list-item>

            <v-divider class="grey darken-2"></v-divider>

            <div v-for="(link, index) in links" :key="index">
                <v-list-item
                    v-if="!link.children"
                    active-class="blue--text text--lighten-4"
                    :to="link.path"
                    :href="link.href"
                    target="__blank"
                >
                    <v-list-item-action>
                        <v-icon>{{ link.icon }}</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title
                            v-text="$t(`drawer.menu.${link.name}`)"
                        ></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group
                    v-else
                    :prepend-icon="link.icon"
                    color="none"
                    no-action
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title
                                v-text="$t(`drawer.menu.${link.name}`)"
                            ></v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item
                        v-for="(item, i) in link.children"
                        :key="i"
                        active-class="blue--text text--lighten-4"
                        :to="item.path"
                        :href="item.href"
                        target="__blank"
                        link
                    >
                        <v-list-item-content>
                            <v-list-item-title>
                                {{
                                    $t(
                                        `drawer.children.${link.name}.${item.name}`,
                                    )
                                }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </div>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import drawerLinks from './DrawerLinks'

export default {
    props: ['drawer'],

    data: () => {
        return {
            openedDrawer: null,
        }
    },

    watch: {
        drawer(value) {
            this.openedDrawer = value
        },

        openedDrawer(value) {
            this.$emit('change', value)
        },
    },

    computed: {
        links() {
            return drawerLinks.filter(({ permission }) => {
                if (!permission) {
                    return true
                }

                if (this.isWhiteLabel && permission == 'isWhiteLabel') {
                    return true
                }

                return false
            })
        },

        isWhiteLabel() {
            return !!this.$store.getters['reseller/isWhiteLabel']
        },
    },

    created() {
        this.openedDrawer = this.drawer
    },
}
</script>
